/**
 * 管理画面 工事情報入力: 郵便番号の検索ボタン押下時に住所（都道府県を含む）を自動入力する。
 */
import { bindJapanesePostalCodeLookup } from '../share/japanese-postal-code-lookup';

(function bootstrapAdminOrdersInstallationPostalLookup() {
    const installationForm = document.querySelector('.orders-installation-edit-form');
    const zipCodeInput = document.getElementById('zip_code');
    const zipCodeLookupButton = document.getElementById('zip_code_lookup');
    const addressInput = document.getElementById('address');

    if (!(installationForm instanceof HTMLFormElement)) {
        return;
    }
    if (!(zipCodeInput instanceof HTMLInputElement)) {
        return;
    }
    if (!(zipCodeLookupButton instanceof HTMLButtonElement)) {
        return;
    }
    if (!(addressInput instanceof HTMLInputElement)) {
        return;
    }

    const postalLookupErrorMessage = installationForm.dataset.postalLookupErrorMessage ?? '';

    bindJapanesePostalCodeLookup({
        postalCodeInput: zipCodeInput,
        searchButton: zipCodeLookupButton,
        onResolved(lookupResult) {
            if (typeof window.jpenergyClearClientBlockMessages === 'function') {
                window.jpenergyClearClientBlockMessages();
            }

            addressInput.value = lookupResult.fullAddress;
        },
        onRequestError() {
            if (
                typeof window.jpenergyShowClientBlockMessage === 'function'
                && postalLookupErrorMessage !== ''
            ) {
                window.jpenergyShowClientBlockMessage('warning', postalLookupErrorMessage);
            }
        },
    });
})();
